require('./bootstrap');

import { createApp } from "vue";
import App from './App.vue';
import router from './router';

const app = createApp({
    components: {
        'app': App
    }
});

app.use(router).mount("#app");

